import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

// Used 4x across 4 files — bold label/heading text (section titles, form labels)
export const BoldTypography = styled(Typography)({
  fontWeight: 'bold',
});

// Used 3x across 3 files — profile/account subtitle that truncates without wrapping
export const TruncatedSubtitle = styled(Typography)({
  marginBottom: 8, // theme.spacing(1)
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
